<template>
  <div class="intro-area pd-top-90 mt-md-4">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-3 col-md-6 wow animated fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay="0.1s"
        >
          <div class="intro-area-inner">
            <div class="thumb mb-4">
              <img
                :src="require('@/assets/img/icon/service-1.png')"
                style="height: 70px; width: 70px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Desarrollo de Aplicaciones Web y Móviles</h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-6 wow animated fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay="0.2s"
        >
          <div class="intro-area-inner">
            <div class="thumb mb-4">
              <img
                :src="require('@/assets/img/icon/service-2.png')"
                style="height: 70px; width: 70px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Arquitectura de</h4>
              <h4>Software</h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-6 wow animated fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay="0.3s"
        >
          <div class="intro-area-inner">
            <div class="thumb mb-4">
              <img
                :src="require('@/assets/img/icon/service-5.png')"
                style="height: 70px; width: 70px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Gestión de</h4>
              <h4>Proyectos</h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-6 wow animated fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay="0.4s"
        >
          <div class="intro-area-inner">
            <div class="thumb mb-4">
              <img
                :src="require('@/assets/img/icon/service-4.png')"
                style="height: 70px; width: 70px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Mantenimiento y Soporte</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro"
};
</script>



// WEBPACK FOOTER //
// src/components/page/home/Intro.vue